/*
 * Module for handling selectable lists
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/selectableList/selectableListView",
], function (Marionette, Messenger, SelectableListView) {
  var SelectableListController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "selectableList";
      this.region = options.region;
      this.nameAttribute = options.nameAttribute ? options.nameAttribute : "name"; //use "name" as the backup attribute if one isn't provided
      this.namespace = options.namespace; //optional namespace parameter
      this.selectedModel = null;
      this._setUpVents();
    },
    show: function (collection) {
      this.collection = collection;
      this.view = this._setUpView(this.collection);
      this.showRegion(this.view, { loading: true });
    },
    focus: function () {
      if (this.isOpen && this.view) {
        this.view.focus();
      }
    },
    /*
     * Default implementation, may be overwritten to provide custom functionality,
     * such as saving procedures...
     */
    selectItem: function (clickedModel) {
      //apply namespacing if provided
      var namespace = this.namespace ? this.namespace + ":" : "";
      if (this.selectedModel !== null) {
        var selectedModel = this.selectedModel;
        if (!this._onBeforeUnselect(selectedModel) || !this._onBeforeSelect(clickedModel)) {
          return;
        }
        selectedModel.off("remove", this._onSelectedModelRemoved, this);
        this._markAsUnselected(); //unselect current item
        Messenger.vent.trigger(namespace + "list:item:unselected", selectedModel);
        this.selectedModel = null;
        this._onUnselect(selectedModel);
      } else if (!this._onBeforeSelect(clickedModel)) {
        return;
      }
      this.selectedModel = clickedModel;
      if (this.selectedModel !== null) {
        this._markAsSelected();
        this.selectedModel.on("remove", this._onSelectedModelRemoved, this);
        Messenger.vent.trigger(namespace + "list:item:selected", clickedModel);
        this._onSelect(clickedModel);
      }
    },
    unselectItem: function () {
      if (this.selectedModel) {
        this._markAsUnselected();
      }
    },
    _onBeforeSelect: function (/*model*/) {
      return true;
    },
    _onBeforeUnselect: function (/*model*/) {
      return true;
    },
    _onSelect: function (/*model*/) {},
    _onUnselect: function (/*model*/) {},
    _setUpView: function (items) {
      var view = new SelectableListView.selectableList({
        collection: items,
        nameAttribute: this.nameAttribute,
      });
      view.on(
        "itemview:click:item",
        function (clickedView) {
          this.selectItem(clickedView.model);
        },
        this,
      );
      view.on(
        "render itemview:render",
        function () {
          if (this.selectedModel) {
            this._markAsSelected();
          }
        },
        this,
      );
      return view;
    },
    _markAsSelected: function () {
      var view = this.view.children.findByModel(this.selectedModel);
      if (!view) {
        //if we can't find the view, try again by matching the selected model's attributes with an itme from the collection
        //this is necessary if this.selectedModel was from a filtered list and we need to find the corresponding model in the full list
        var model;
        this.collection.each(function (item) {
          if (!model) {
            if (item.get(this.nameAttribute) === this.selectedModel.get(this.nameAttribute)) {
              model = item;
            }
          }
        }, this);
        if (model) {
          this.selectedModel = model; //reassign model
          view = this.view.children.findByModel(model);
        }
      }
      if (view) {
        view.select(); //apply 'selected' class
      }
    },
    _markAsUnselected: function () {
      try {
        var view = this.view.children.findByModel(this.selectedModel);
        if (view) {
          view.unselect(); //remove 'selected' class
        }
      } catch (e) {
        console.error("Could not unselect model: ", e);
      }
    },
    _onSelectedModelRemoved: function (model) {
      //if the model is removed, then just set this.selectedModel to null
      if (model === this.selectedModel) {
        this.selectedModel.off("remove", this._onSelectedModelRemoved, this);
        this._markAsUnselected(); //unselect current item
        this.selectedModel = null;
        //apply namespacing if provided
        var namespace = this.namespace ? this.namespace + ":" : "";
        Messenger.vent.trigger(namespace + "list:item:unselected", model);
      }
    },
    _setUpVents: function () {},
  });

  return SelectableListController;
});
